import { render, staticRenderFns } from "./Undo.vue?vue&type=template&id=235cc1bc&scoped=true"
import script from "./Undo.vue?vue&type=script&lang=ts"
export * from "./Undo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235cc1bc",
  null
  
)

export default component.exports